import { render, staticRenderFns } from "./CAxASCxSocialPt1Page.vue?vue&type=template&id=b91d180e"
import script from "./CAxASCxSocialPt1Page.vue?vue&type=script&lang=js"
export * from "./CAxASCxSocialPt1Page.vue?vue&type=script&lang=js"
import style0 from "./CAxASCxSocialPt1Page.vue?vue&type=style&index=0&id=b91d180e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports